function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0daf7a0d\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!./login.component.less")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./login.component.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0daf7a0d\",\"hasScoped\":true}!./login.component.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0daf7a0d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/login/index.vue
// module id = 189
// module chunks = 1